/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Document_Type_Enum =
  /** file related to a comment */
  | 'COMMENT_FILE'
  | 'DELIVERY_NOTE'
  /** type for invoice document */
  | 'INVOICE'
  | 'ORDER_SUMMARY'
  | 'PURCHASE_ORDER';

export type Invoice_Type_Enum =
  /** commission invoice */
  | 'COMMISSION'
  /** order invoice */
  | 'ORDER';

export type DocumentDataFragment = { id: string, path: string, domain: string, type: Types.Document_Type_Enum, invoice: { type: Types.Invoice_Type_Enum, reference: string | null, revised_reference: string | null, price_excl_tax: number | null, revised_price_excl_tax: number | null, price_incl_tax: number | null, revised_price_incl_tax: number | null, comment: string | null, modified_date: string, order: { updater: { auth_provider_avatar_url: string | null, first_name: string, last_name: string, default_avatar: { domain: string | null, path: string } | null } | null } | null } | null };

export type DocumentsByOrderQueryVariables = Exact<{
  orderId: string;
  isBuyer: boolean;
}>;


export type DocumentsByOrderQuery = { documentAsBuyer?: Array<{ id: string, path: string, domain: string, type: Types.Document_Type_Enum, invoice: { type: Types.Invoice_Type_Enum, reference: string | null, revised_reference: string | null, price_excl_tax: number | null, revised_price_excl_tax: number | null, price_incl_tax: number | null, revised_price_incl_tax: number | null, comment: string | null, modified_date: string, order: { updater: { auth_provider_avatar_url: string | null, first_name: string, last_name: string, default_avatar: { domain: string | null, path: string } | null } | null } | null } | null }>, documentAsSupplier?: Array<{ id: string, path: string, domain: string, type: Types.Document_Type_Enum, invoice: { type: Types.Invoice_Type_Enum, reference: string | null, revised_reference: string | null, price_excl_tax: number | null, revised_price_excl_tax: number | null, price_incl_tax: number | null, revised_price_incl_tax: number | null, comment: string | null, modified_date: string, order: { updater: { auth_provider_avatar_url: string | null, first_name: string, last_name: string, default_avatar: { domain: string | null, path: string } | null } | null } | null } | null }> };

export const DocumentDataFragmentDoc = /*#__PURE__*/ gql`
    fragment documentData on document {
  id
  path
  domain
  type
  invoice {
    type
    reference
    revised_reference
    price_excl_tax
    revised_price_excl_tax
    price_incl_tax
    revised_price_incl_tax
    comment
    modified_date
    order {
      updater {
        auth_provider_avatar_url
        first_name
        last_name
        default_avatar {
          domain
          path
        }
      }
    }
  }
}
    `;
export const DocumentsByOrderDocument = /*#__PURE__*/ gql`
    query documentsByOrder($orderId: uuid!, $isBuyer: Boolean!) {
  documentAsBuyer: document(
    where: {order_id: {_eq: $orderId}, _or: [{invoice: {type: {_neq: COMMISSION}}}, {invoice_id: {_is_null: true}}]}
  ) @include(if: $isBuyer) {
    ...documentData
  }
  documentAsSupplier: document(where: {order_id: {_eq: $orderId}}) @skip(if: $isBuyer) {
    ...documentData
  }
}
    ${DocumentDataFragmentDoc}`;

/**
 * __useDocumentsByOrderQuery__
 *
 * To run a query within a React component, call `useDocumentsByOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsByOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsByOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      isBuyer: // value for 'isBuyer'
 *   },
 * });
 */
export function useDocumentsByOrderQuery(baseOptions: Apollo.QueryHookOptions<DocumentsByOrderQuery, DocumentsByOrderQueryVariables> & ({ variables: DocumentsByOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>(DocumentsByOrderDocument, options);
      }
export function useDocumentsByOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>(DocumentsByOrderDocument, options);
        }
// @ts-ignore
export function useDocumentsByOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>): Apollo.UseSuspenseQueryResult<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>;
export function useDocumentsByOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>): Apollo.UseSuspenseQueryResult<DocumentsByOrderQuery | undefined, DocumentsByOrderQueryVariables>;
export function useDocumentsByOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>(DocumentsByOrderDocument, options);
        }
export type DocumentsByOrderQueryHookResult = ReturnType<typeof useDocumentsByOrderQuery>;
export type DocumentsByOrderLazyQueryHookResult = ReturnType<typeof useDocumentsByOrderLazyQuery>;
export type DocumentsByOrderSuspenseQueryHookResult = ReturnType<typeof useDocumentsByOrderSuspenseQuery>;
export type DocumentsByOrderQueryResult = Apollo.QueryResult<DocumentsByOrderQuery, DocumentsByOrderQueryVariables>;